// extracted by mini-css-extract-plugin
export default {"background":"trustly_background__NXfoG","control":"trustly_control__fMd7M","leftSide":"trustly_leftSide__uQ5dU","rightSide":"trustly_rightSide__CVG8N"};